export const FALLBACK_LANGUAGE_CODE = 'pt-BR';

export const COUNTRY_LANGUAGE_CODE = Object.freeze({
  BR: 'pt-BR',
  US: 'en-US',
  MX: 'es-MX',
});

export const LANGUAGE_CODES = Object.freeze(Object.values(COUNTRY_LANGUAGE_CODE));

export const LANG_LANGUAGE_CODE = Object.freeze({
  pt: COUNTRY_LANGUAGE_CODE.BR,
  en: COUNTRY_LANGUAGE_CODE.US,
  es: COUNTRY_LANGUAGE_CODE.MX,
});

export const MOMENT_LOCALES = Object.freeze({
  [COUNTRY_LANGUAGE_CODE.BR]: 'pt-br',
  [COUNTRY_LANGUAGE_CODE.US]: 'en',
  [COUNTRY_LANGUAGE_CODE.MX]: 'es-mx',
});

export function normalizeLanguageCode(language) {
  if (typeof language !== 'string') {
    return null;
  }

  const normalizedLanguage = language.trim().replace('_', '-');
  const supportedLanguage = LANGUAGE_CODES.find(
    (code) => code.toLowerCase() === normalizedLanguage.toLowerCase(),
  );

  if (supportedLanguage) {
    return supportedLanguage;
  }

  return LANG_LANGUAGE_CODE[normalizedLanguage.split('-')[0].toLowerCase()] || null;
}
